module.exports = __webpack_public_path__ + "img/banner-img.fc212ce5.jpg";